export interface Partner {
  id: number;
  name: string;
  contacts: string;
  status: string;
  responsible: string;
  created_at: string;
  work_phone?: string;
  website?: string;
  employees_count?: string;
  comment?: string;
  work_email?: string;
  inn?: string;
  interaction_format?: string;
  legal_name?: string;
  legal_address?: string;
  mailing_address?: string;
  director_name?: string;
  has_nda_blank?: boolean;
  has_nda_scan?: boolean;
  signed_in_edo?: boolean;
}

export const mockPartners: Partner[] = [
  {
    id: 1,
    name: "ООО 'ТехноСтарт'",
    contacts: "Иван Петров, +7 (495) 123-45-67",
    status: "Активный",
    responsible: "Мария Козлова",
    created_at: "2024-01-15T10:30:00Z",
    work_phone: "+7 (495) 123-45-67",
    website: "https://techstart.ru",
    employees_count: "50-100",
    comment: "Крупный партнер",
    work_email: "info@techstart.ru",
    inn: "7701234567",
    interaction_format: "Регулярные встречи",
  },
  {
    id: 2,
    name: "ИП Сидоров А.В.",
    contacts: "Анна Сидорова, +7 (495) 234-56-78",
    status: "В работе",
    responsible: "Алексей Смирнов",
    created_at: "2024-01-14T14:20:00Z",
  },
  {
    id: 3,
    name: "ООО 'Инновации'",
    contacts: "Сергей Лебедев, +7 (495) 345-67-89",
    status: "Активный",
    responsible: "Елена Волкова",
    created_at: "2024-01-13T09:15:00Z",
  },
  {
    id: 4,
    name: "ЗАО 'Прогресс'",
    contacts: "Татьяна Соколова, +7 (495) 456-78-90",
    status: "Приостановлен",
    responsible: "Дмитрий Орлов",
    created_at: "2024-01-12T16:45:00Z",
  },
  {
    id: 5,
    name: "ИП Кузнецов С.П.",
    contacts: "Михаил Кузнецов, +7 (495) 567-89-01",
    status: "Активный",
    responsible: "Анна Морозова",
    created_at: "2024-01-11T11:30:00Z",
  },
  {
    id: 6,
    name: "ООО 'Стартап'",
    contacts: "Ольга Новикова, +7 (495) 678-90-12",
    status: "В работе",
    responsible: "Сергей Лебедев",
    created_at: "2024-01-10T13:20:00Z",
  },
  {
    id: 7,
    name: "ИП Новиков В.И.",
    contacts: "Владимир Новиков, +7 (495) 789-01-23",
    status: "Активный",
    responsible: "Татьяна Соколова",
    created_at: "2024-01-09T08:10:00Z",
  },
  {
    id: 8,
    name: "ООО 'Будущее'",
    contacts: "Елена Будущая, +7 (495) 890-12-34",
    status: "Приостановлен",
    responsible: "Михаил Новиков",
    created_at: "2024-01-08T15:35:00Z",
  },
  {
    id: 9,
    name: "ИП Морозов А.С.",
    contacts: "Александр Морозов, +7 (495) 901-23-45",
    status: "Активный",
    responsible: "Ольга Кузнецова",
    created_at: "2024-01-07T12:15:00Z",
  },
  {
    id: 10,
    name: "ООО 'Развитие'",
    contacts: "Наталья Развитие, +7 (495) 012-34-56",
    status: "В работе",
    responsible: "Иван Петров",
    created_at: "2024-01-06T09:45:00Z",
  },
  {
    id: 11,
    name: "ООО 'Интеграция'",
    contacts: "Захарова Т.И. (+7 495 123-98-76)",
    status: "Активный",
    responsible: "Николаев Дмитрий Петрович",
    created_at: "2024-03-12T00:00:00Z",
  },
];
